export enum EnvelopeUrlSegment {
    Document = 'document',
    Envelope = 'envelope',
    Envelopes = 'envelopes',
    Resend = 'resend',
    Send = 'send',
    Signatory = 'signatory',
}
